import { __rest, __assign } from 'tslib';
import React from 'react';
import { useFormContext, useController, get } from 'react-hook-form';
import { Field, ToggleSwitch } from '@panwds/react-ui';

/**
 * Renders a Toggle connected to the form. All extra props will get passed to the Toggle.
 */
var Toggle = function (props) {
    var _a;
    var name = props.name, label = props.label, description = props.description, tooltip = props.tooltip, disabled = props.disabled, _b = props.register, register = _b === void 0 ? {} : _b, _c = props.defaultValue, defaultValue = _c === void 0 ? false : _c, showLabel = props.showLabel, rest = __rest(props, ["name", "label", "description", "tooltip", "disabled", "register", "defaultValue", "showLabel"]);
    var context = useFormContext();
    /* istanbul ignore next */
    if (process.env.NODE_ENV === "development" && context === null) {
        throw new Error("Attempted to render Toggle outside of a Form context. Make sure your component is rendered inside <Form>.");
    }
    var formState = context.formState;
    var _d = useController({
        name: name,
        defaultValue: defaultValue,
        rules: register
    }).field, onChange = _d.onChange, value = _d.value;
    return (React.createElement(Field, { label: label, control: React.createElement(ToggleSwitch, __assign({}, rest, { disabled: disabled, checked: value, onClick: function () { return onChange(!value); } })), error: (_a = get(formState.errors, name)) === null || _a === void 0 ? void 0 : _a.message, description: description, tooltip: tooltip, disabled: disabled, showLabel: showLabel }));
};

export { Toggle };
//# sourceMappingURL=Toggle.esm.js.map
